import { WeekmenuData } from "@app/types/root-state/weekmenu"

// import { Recipe, WeekMenuData } from "../../types"

export enum WeekMenuActionTypes {
    GetWeekMenuLoading = "week-menu:get-loading",
    GetWeekMenuLoaded = "week-menu:get-loaded",
    GetWeekMenuError = "week-menu:get-error",
    GetWeekMenuSuccess = "week-menu:get-success",
    GetWeekMenuFromCache = "week-menu:from-cache",

    // GetAllWeekMenusLoading = "week-menu:get-all-loading",
    // GetAllWeekMenusLoaded = "week-menu:get-all-loaded",
    // GetAllWeekMenusError = "week-menu:get-all-error",
    // GetAllWeekMenusSuccess = "week-menu:get-all-success",
}

interface BaseReturn {
    type: WeekMenuActionTypes
    payload?: any
}

// Get single
export interface GetWeekMenuLoading extends BaseReturn {
    type: WeekMenuActionTypes.GetWeekMenuLoading
}
export const getWeekMenuLoading = (): GetWeekMenuLoading => ({
    type: WeekMenuActionTypes.GetWeekMenuLoading,
})

export interface GetWeekMenuLoaded extends BaseReturn {
    type: WeekMenuActionTypes.GetWeekMenuLoaded
}
export const getWeekMenuLoaded = (): GetWeekMenuLoaded => ({
    type: WeekMenuActionTypes.GetWeekMenuLoaded,
})

export interface GetWeekMenuSuccess extends BaseReturn {
    type: WeekMenuActionTypes.GetWeekMenuSuccess
    payload: WeekmenuData[]
}
export const getWeekMenuSuccess = (data: WeekmenuData[]): GetWeekMenuSuccess => ({
    type: WeekMenuActionTypes.GetWeekMenuSuccess,
    payload: data,
})
export interface GetWeekMenuFromCache extends BaseReturn {
    type: WeekMenuActionTypes.GetWeekMenuFromCache
    payload: WeekmenuData[]
}
export const getWeekMenuFromCache = (data: WeekmenuData[]): GetWeekMenuFromCache => ({
    type: WeekMenuActionTypes.GetWeekMenuFromCache,
    payload: data,
})

export interface GetWeekMenuError extends BaseReturn {
    type: WeekMenuActionTypes.GetWeekMenuError
    payload: Error
}
export const getWeekMenuError = (error: Error): GetWeekMenuError => ({
    type: WeekMenuActionTypes.GetWeekMenuError,
    payload: error,
})

// // Get all
// export interface GetAllWeekMenusLoading extends BaseReturn {
//     type: WeekMenuActionTypes.GetAllWeekMenusLoading
// }
// export const getAllWeekMenusLoading = (): GetAllWeekMenusLoading => ({
//     type: WeekMenuActionTypes.GetAllWeekMenusLoading,
// })

// export interface GetAllWeekMenusLoaded extends BaseReturn {
//     type: WeekMenuActionTypes.GetAllWeekMenusLoaded
// }
// export const getAllWeekMenusLoaded = (): GetAllWeekMenusLoaded => ({
//     type: WeekMenuActionTypes.GetAllWeekMenusLoaded,
// })

// export interface GetAllWeekMenusSuccess extends BaseReturn {
//     type: WeekMenuActionTypes.GetAllWeekMenusSuccess
//     payload: string
// }
// export const getAllWeekMenusSuccess = (data: string): GetAllWeekMenusSuccess => ({
//     type: WeekMenuActionTypes.GetAllWeekMenusSuccess,
//     payload: data,
// })

// export interface GetAllWeekMenusError extends BaseReturn {
//     type: WeekMenuActionTypes.GetAllWeekMenusError
//     payload: Error
// }
// export const getAllWeekMenusError = (error: Error): GetAllWeekMenusError => ({
//     type: WeekMenuActionTypes.GetAllWeekMenusError,
//     payload: error,
// })

export type WeekMenuActions =
    | GetWeekMenuLoading
    | GetWeekMenuLoaded
    | GetWeekMenuError
    | GetWeekMenuSuccess
    | GetWeekMenuFromCache
// | GetAllWeekMenusLoading
// | GetAllWeekMenusLoaded
// | GetAllWeekMenusError
// | GetAllWeekMenusSuccess
